// extracted by mini-css-extract-plugin
module.exports = {"Panel":"VUzRy3f6jifV5+oqzGqucQ==","PanelBottom":"yVXJhcfuuAQEzDIUCLv6-Q=="};